import { FolderMultipleImageIcon } from './FolderMultipleImageIcon';

/**
 * author: Google
 * id 29BE785E-BAAB-4824-A0BF-6892D8027B1E
 * name folder-multiple-image
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-multiple-image.svg
 * tags
 * - Files / Folders 
 */
export const PermMediaIcon = FolderMultipleImageIcon;
export default PermMediaIcon